import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LOGO_APP, START_MODE} from '../../../app.constants';
import {ActivityService, DialogService} from 'ng-metro4';
import { AuthService } from 'src/app/services/auth.service';
import {Signin} from '../../../models/admin/signin';
import {TokenStorageService} from '../../../services/token-storage.service';
import {confirmation} from '../../../mocks/confirm-response-for-request';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {FindEssentialService} from '../../../services/find-essential.service';
import {GenericsService} from '../../../services/generics.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public signinForm: FormGroup;
  logo: string;
  navigated = false;
  loginMode = 0;
  submitted = false;
  signinModel: Signin;
  private clientOuPatient: any;

  constructor(
    private fb: FormBuilder,
    private activityService: ActivityService,
    private authService: AuthService,
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private dialogService: DialogService,
    public translate: TranslateService,
    public findEssential: FindEssentialService,
    public genericsService: GenericsService,
    private route: ActivatedRoute
  ) {
    this.logo = LOGO_APP;
  }

  ngOnInit(): void {
    if (environment.startMode !== START_MODE.DEV) {
      this.genericsService.getTenantIdFromUrl();
    }
    this.onLastLicense();
    this.initForm();
  }

  onLastLicense(): void {
    this.submitted = true;
    this.genericsService.getResourceGescomV1(`/system/last/license`)
      .then((res: any) => {
        if (res && res.data) {
          this.tokenStorageService.saveNbrUser(res.data?.nbrUser);
          this.onDecrypeLicenseAndCheck(res.data.cas);
        }
      }).catch((err) => {
      this.navigated = false;
      if (err.error.message) {
        Swal.fire(confirmation(err.error.message, 'center', 'error', false, 5000));
      } else {
        Swal.fire(confirmation(err?.error ??
          'Le serveur est actuellement indisponible. Veuillez réessayer plus tard.', 'center', 'error', false, 5000));
      }
    });
  }

  onDecrypeLicenseAndCheck(licenseKey: string): void {
    this.submitted = true;
    if (licenseKey) {
      this.genericsService.postResourceGescomV1(`/system/decrypt/license`, { licenseKey })
        .then((res: any) => {
          const data = res.data;
          console.log(data);
          this.tokenStorageService.saveLicense(data);
          this.getEssentialDataLicence();
          this.initLogin();
        }).catch((err) => {
        this.navigated = false;
        if (err.error.message) {
          Swal.fire(confirmation(err.error.message, 'center', 'error', false, 5000));
        } else {
          Swal.fire(confirmation(err?.error ??
            'Le serveur est actuellement indisponible. Veuillez réessayer plus tard.', 'center', 'error', false, 5000));
        }
      });
    }
  }

  getEssentialDataLicence(): void {
    this.findEssential.getVariableGlobalsParam('CONFIG_NOTIFICATION_VALIDITE_LICENCE').then((value: any) => {
      const jourMaxDeNotification = value.data[0]?.valeur;
      console.log(jourMaxDeNotification);
      this.tokenStorageService.saveJourMaxDeNotificationLicence(jourMaxDeNotification);
    });
  }


  initForm(): void {
    this.signinForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  get f(): any {
    return this.signinForm.controls;
  }

  onCheck(): void {
    const lang = this.tokenStorageService.getLangue() ?? 'FR';
    const isFrench = lang === 'FR';

    const title = isFrench
      ? `Connexion sur un autre appareil détectée`
      : `Connection on another device detected`;

    const message = isFrench
      ? `Vous êtes déjà connecté sur un autre appareil. Si vous continuez, vous serez déconnecté de toutes les autres sessions. Voulez-vous continuer ?`
      : `You are already logged in on another device. If you continue, you will be logged out from all other sessions. Do you want to proceed?`;

    const confirmBtn = isFrench ? `Continuer` : `Continue`;
    const cancelBtn = isFrench ? `Annuler` : `Cancel`;

    this.dialogService
      .confirm(
        title,
        message,
        confirmBtn,
        cancelBtn,
        `pos-fixed pos-center w-vw-30`,
        `primary`,
        ``
      )
      .toPromise()
      .then((result) => {
        if (result) {
          if (this.loginMode) {
            this.onSigninUser();
          } else {
            this.initLogin();
          }
          this.loginMode = 0;
        } else {
          this.loginMode = 0;
        }
      })
      .catch((error: any) => {
        // Handle cancel or error
      });
  }

  initLogin(): void {
    this.route.queryParams.subscribe(params => {
      const token = params.token;
      const idUser = params?.idUser;
      const idDashboard = params?.idDashboard;
      const idSite = params?.idSite;
      const codeSite = params?.codeSite;
      if (token && idUser) {
        this.navigated = true;
        this.tokenStorageService.saveToken(token);
        this.tokenStorageService.saveCurrentSite(idSite);
        this.tokenStorageService.saveCodeSite(codeSite);
        this.getUserId(idUser);
      } else if (token && idDashboard) {
        this.navigated = true;
        this.tokenStorageService.saveToken(token);
        this.getSiteIdDashboard(idSite);
        this.getUserIdDashboard(idDashboard);
      } else {
        if (this.tokenStorageService.getToken() && !this.tokenStorageService.getCurrentSite()) {
          this.router.navigate(['/choice-your-site']);
        } else if (this.tokenStorageService.getToken() && this.tokenStorageService.getCurrentSite()) {
          this.router.navigate(['/home']);
        }
      }
    });
  }

  getSiteIdDashboard(id: any): void {
    this.authService.getSiteDashboard(id).subscribe(res => {
      this.tokenStorageService.saveCurrentSite(res?.data?.id);
      this.tokenStorageService.saveCodeSite(res?.data?.code);
    }, error => {
      this.navigated = false;
    });
  }

  getUserIdDashboard(id: any): void {
    const message = this.tokenStorageService.getLangue() === 'EN' ? 'Loading ...' : 'Chargement ...';
    const activity = this.activityService.open({
      style: 'color',
      text: `<div class="mt-2 display1 fg-darkBlue">${message}</div>`,
      type: 'cycle',
      overlayColor: '#a7a0a0',
    });
    this.authService.getUserDashboard(id).subscribe((res: any) => {
      this.navigated = false;
      this.activityService.close(activity);
      if (res.data.habilitations.length > 0) {
        this.tokenStorageService.saveHabilitations(res.data.habilitations);
      }
      this.tokenStorageService.saveUser(res.data);
      this.tokenStorageService.saveLangue(res.data.langue);
      this.tokenStorageService.saveUsername(res.data.username);

      if (res.data.sites.length > 0) {
        this.tokenStorageService.saveSites(res.data.sites);
        this.router.navigate(['/home']).then(
          () => {
            window.location.reload();
          }
        );
      }
      this.getVariableGlobal();
      this.getSiteDefault();
    }, (error: any) => {
      this.navigated = false;
      this.activityService.close(activity);
      if  (error.error?.code == 410) {
        this.loginMode = 1;
        this.onCheck();
      } else {
        Swal.fire(confirmation(error.error.message, 'center', 'warning', false, 5000));
      }
    });
  }

  /**
   * Connecter un utilisateur en utilisant ses credentials
   */
  onSigninUser(): void {
    this.submitted = true;
    this.signinModel = new Signin(this.f.username.value, this.f.password.value, this.loginMode);
    const message = this.tokenStorageService.getLangue() === 'EN' ? 'Loading ...' : 'Chargement ...';
    const activity = this.activityService.open({
      style: 'color',
      text: `<div class="mt-2 display1 fg-darkBlue">${message}</div>`,
      type: 'cycle',
      overlayColor: '#a7a0a0',
    });
    this.getSiteDefault();
    this.authService.login(this.signinModel).subscribe((result: any) => {
      console.log(result);
      if (result.code === 200) {
        if (result.data.habilitations.length > 0) {
          this.tokenStorageService.saveHabilitations(result.data.habilitations);
        }
        // this.tokenStorageService.saveInterfaceSimplifiee(result.data.interfaceListingSimplifiee);
        this.tokenStorageService.saveToken(result.data.token);
        this.tokenStorageService.saveUser(result.data);
        this.tokenStorageService.saveLangue(result.data.langue);
        this.tokenStorageService.saveUsername(result.data.username);
        this.tokenStorageService.saveTenantID(result.data?.tenantId ? result.data.tenantId : '');
        if (result.data.sites.length > 0) {
          this.tokenStorageService.saveSites(result.data.sites);
          this.router.navigate(['/choice-your-site']);
        } else {
          Swal.fire(confirmation('Vous ne disposez pas de site',
            'center', 'warning', false, 10000)).then((resp: any) => {
            console.log(resp);
            this.tokenStorageService.signOut();
          });
        }
        this.activityService.close(activity);
        this.getVariableGlobal();
      } else {
        this.activityService.close(activity);
        if (result.error) {
          Swal.fire(confirmation(result.error.message ??
            'Le serveur est actuellement indisponible. Veuillez réessayer plus tard.', 'center', 'warning', false, 5000));
        } else {
          Swal.fire(confirmation(result.message, 'center', 'warning', false, 5000));
        }
      }
    }, (error) => {
      console.log(error);
      this.activityService.close(activity);
      if  (error.error?.code == 410) {
        this.loginMode = 1;
        this.onCheck();
      } else if (error.error.message) {
        Swal.fire(confirmation(error.error.message, 'center', 'warning', false, 5000));
      } else {
        Swal.fire(confirmation(error?.error ??
          'Le serveur est actuellement indisponible. Veuillez réessayer plus tard.', 'center', 'error', false, 5000));
      }
    });
  }
  getVariableGlobal(): void {
    this.findEssential.getVariableGlobalsParam('HOSPITALISATION_GESCOM').then((resp: any) => {
      if (resp.code === 200) {
        this.clientOuPatient = resp.data[0]?.valeur;
        this.tokenStorageService.saveHospitalisationGescom(this.clientOuPatient);
      }
    });
  }
  getSiteDefault(): void {
    this.findEssential.getVariableGlobalsParam('CODE_SITE').then((value: any) => {
      const valueSite = value.data[0].valeur;

      if (valueSite) {
        this.tokenStorageService.saveCodeSite(valueSite);
      }
    });
  }

  getUserId(id) {
    const message = this.tokenStorageService.getLangue() === 'EN' ? 'Loading ...' : 'Chargement ...';
    const activity = this.activityService.open({
      style: 'color',
      text: `<div class="mt-2 display1 fg-darkBlue">${message}</div>`,
      type: 'cycle',
      overlayColor: '#a7a0a0',
    });
    this.authService.getUser(id).subscribe(res => {
      this.navigated = false;
      this.activityService.close(activity);
      if (res.data.habilitations?.length > 0) {
        this.tokenStorageService.saveHabilitations(res.data.habilitations);
      }
      this.tokenStorageService.saveUser(res.data);
      this.tokenStorageService.saveLangue(res.data.langue);
      this.tokenStorageService.saveUsername(res.data.username);
      if (res.data.sites?.length > 0) {
        this.tokenStorageService.saveSites(res.data.sites);
        this.router.navigate(['/home']).then(
          () => {
            window.location.reload();
          }
        );
      }
      this.getVariableGlobal();
      // this.getSiteDefault()
    }, error => {
      this.navigated = false;
      this.activityService.close(activity);
      if  (error.error?.code == 410) {
        this.loginMode = 1;
        this.onCheck();
      } else {
        Swal.fire(confirmation(error.error.message, 'center', 'warning', false, 5000));
      }
    });
  }
}
